import {CountryShort} from "./country-short";
import {OrganiserLinks} from "./organiser-links";
import {OrganiserPaymentData} from "./organiser-payment-data";

export class Organiser {
  id?: number;
  ownerId?: number;
  userId?: number;
  name?: string;
  fullName?: string;
  website?: string;
  email?: string;
  phone?: string;
  address?: string;
  place?: string;
  country?: CountryShort;
  appPinCode?: string;
  appPinValidUntil?: Date;
  image?: string;
  imageIcon?: string;
  imageMini?: string;
  imageSmall?: string;
  imageMedium?: string;
  links?: string;
  organiserLinks?: OrganiserLinks;
  info?: string;
  created?: Date;
  modified?: Date;
  zip?: string;
  requestStatus?: number;
  organiserPaymentData?: OrganiserPaymentData;

  constructor() {
    this.id = undefined;
    this.ownerId = undefined;
    this.name = undefined;
    this.fullName = undefined;
    this.website = undefined;
    this.email = undefined;
    this.phone = undefined;
    this.address = undefined;
    this.place = undefined;
    this.country = undefined;
    this.appPinCode = undefined;
    this.appPinValidUntil = undefined;
    this.image = undefined;
    this.imageIcon = undefined;
    this.imageMedium = undefined;
    this.imageMini = undefined;
    this.imageSmall = undefined;
    this.links = undefined;
    this.organiserLinks = new OrganiserLinks();
    this.info = undefined;
    this.zip = undefined;
    this.requestStatus = undefined;
    this.organiserPaymentData = new OrganiserPaymentData();
  }
}
